module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mostraGridPublicoAlvo),
      expression: "mostraGridPublicoAlvo"
    }]
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.somenteLeitura !== false) ? _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.formEditavel) ? _c('button', {
    staticClass: "btn btn-primary btn-flat",
    attrs: {
      "uib-tooltip": "Adiciona um público alvo",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.mostraGridPublicoAlvo = !_vm.mostraGridPublicoAlvo
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Novo Público alvo")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.formEditavel) ? _c('br') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.somenteLeitura !== false) ? _c('div', [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "bordered": _vm.table.bordered,
      "items": _vm.table.items,
      "hover": _vm.table.hover,
      "fields": _vm.table.fields,
      "filter": _vm.table.filter,
      "current-page": _vm.table.currentPage,
      "per-page": _vm.table.perPage,
      "sort-by": _vm.table.sortBy,
      "sort-desc": _vm.table.sortDesc,
      "empty-text": "Nenhum registro encontrado"
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "nr_jovens",
      fn: function(row) {
        return [_vm._v(_vm._s(row.value))]
      }
    }, {
      key: "nr_mulheres",
      fn: function(row) {
        return [_vm._v(_vm._s(row.value))]
      }
    }, (_vm.somenteLeitura !== false && _vm.formEditavel) ? {
      key: "actions",
      fn: function(row) {
        return [_c('div', [_c('b-button', {
          staticClass: "btn btn-primary btn-sm btn-flat",
          attrs: {
            "type": "button",
            "disabled": false
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.edita(row.item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil-square-o",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Editar")]), _vm._v(" "), _c('b-button', {
          directives: [{
            name: "confirm",
            rawName: "v-confirm",
            value: ({
              ok: function (retorno) { return _vm.exclui(row); },
              cancel: _vm.doNothing,
              message: 'Deseja <b>APAGAR</b> o item ' + row.item.fonte.ds_descricao + ' ?'
            }),
            expression: "{ok: retorno => exclui(row), cancel: doNothing,\n                           message: 'Deseja <b>APAGAR</b> o item ' + row.item.fonte.ds_descricao + ' ?'}"
          }],
          staticClass: "btn btn-danger btn-sm btn-flat",
          attrs: {
            "type": "button",
            "disabled": false,
            "data-cy": "exclui-publico-alvo"
          }
        }, [_c('i', {
          staticClass: "fa fa-trash",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Excluir")])], 1)]
      }
    } : null], null, true)
  })], 1)], 1) : _vm._e()])]), _vm._v(" "), (!_vm.mostraGridPublicoAlvo) ? _c('div', {
    staticClass: "row well well-sm no-shadow animated fadeInDownOutUp",
    staticStyle: {
      "padding-left": "0"
    },
    attrs: {
      "disabled": _vm.mostraGridPublicoAlvo
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Público-alvo')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Público-alvo:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.publicoAlvo.fonte),
      expression: "publicoAlvo.fonte"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Público-alvo",
      "data-vv-as": "Descrição do Público-alvo",
      "data-cy": "fonte"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.publicoAlvo, "fonte", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.publicosAlvo), function(publico) {
    return _c('option', {
      domProps: {
        "value": publico
      }
    }, [_vm._v(_vm._s(publico.ds_descricao))])
  }), 0)]), _vm._v(" "), (_vm.errors.first('Público-alvo')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Público-alvo')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Tipo público-alvo')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Tipo público-alvo:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.publicoAlvo.ds_tipo_publico_alvo),
      expression: "publicoAlvo.ds_tipo_publico_alvo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "data-cy": "ds_tipo_publico_alvo",
      "data-vv-as": "Tipo do Público-alvo",
      "name": "Tipo público-alvo"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.publicoAlvo, "ds_tipo_publico_alvo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("Outros")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "20"
    }
  }, [_vm._v("Agricultores familiares")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "30"
    }
  }, [_vm._v("Assentados da reforma agrária")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "40"
    }
  }, [_vm._v("Extrativistas")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "50"
    }
  }, [_vm._v("Indígenas")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "60"
    }
  }, [_vm._v("Catadores de materiais recicláveis")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "70"
    }
  }, [_vm._v("Associados")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "80"
    }
  }, [_vm._v("Jovens de 18 a 24 anos (ambos os sexos) do Programa Jovem Aprendiz no Campo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "90"
    }
  }, [_vm._v("Estudantes Ensino Superior Público (UFOB) da Área de alimentos (18 a 24 anos - ambos os sexos)")])])]), _vm._v(" "), (_vm.errors.first('Tipo público-alvo')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Tipo público-alvo')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('participantes diretos')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Participantes diretos:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.publicoAlvo.nr_participantes_diretos),
      expression: "publicoAlvo.nr_participantes_diretos"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:1|max_value:2147483647'),
      expression: "'required|min_value:1|max_value:2147483647'"
    }],
    staticClass: "form-control",
    attrs: {
      "data-cy": "nr_participantes_diretos",
      "name": "participantes diretos",
      "data-vv-as": "Participantes Diretos",
      "min": "1",
      "max": "2147483647",
      "type": "number",
      "required": ""
    },
    domProps: {
      "value": (_vm.publicoAlvo.nr_participantes_diretos)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.publicoAlvo, "nr_participantes_diretos", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('participantes diretos')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('participantes diretos')))]) : _vm._e()]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.first('participantes Indiretos')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Participantes indiretos:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', [(false) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.publicoAlvo.nr_participantes_indiretos),
      expression: "publicoAlvo.nr_participantes_indiretos"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max_value:2147483647'),
      expression: "'max_value:2147483647'"
    }],
    staticClass: "form-control",
    attrs: {
      "data-cy": "nr_participantes_indiretos",
      "name": "participantes Indiretos",
      "data-vv-as": "Participantes Indiretos",
      "type": "number",
      "max": "2147483647"
    },
    domProps: {
      "value": (_vm.publicoAlvo.nr_participantes_indiretos)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.publicoAlvo, "nr_participantes_indiretos", $event.target.value)
      }
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.errors.first('participantes Indiretos')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('participantes Indiretos')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticStyle: {
      "color": "red",
      "margin-bottom": "10px"
    }
  }, [_vm._v("* Dentre os participantes diretos informe, se houver, quantos são Jovens e/ou Mulheres")]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.first('Atende jovens')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Atende jovens?")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.jovensBool),
      expression: "jovensBool"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "data-cy": "jovensBool",
      "name": "Atende jovens"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.jovensBool = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.alteraJovens]
    }
  }, [_c('option', {
    attrs: {
      "value": "Sim"
    },
    domProps: {
      "selected": _vm.publicoAlvo.nr_jovens
    }
  }, [_vm._v("Sim")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Não"
    }
  }, [_vm._v("Não")])])]), _vm._v(" "), (_vm.errors.first('Atende jovens')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Atende jovens')))]) : _vm._e()])]), _vm._v(" "), (_vm.jovensBool === 'Sim') ? _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.first('Número de jovens atendidos')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Número de jovens atendidos:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.publicoAlvo.nr_jovens),
      expression: "publicoAlvo.nr_jovens"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.jovensBool === 'Sim'
      }),
      expression: "{required: jovensBool === 'Sim'}"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Número de jovens atendidos",
      "type": "number",
      "min": "1",
      "max": _vm.publicoAlvo.nr_participantes_diretos
    },
    domProps: {
      "value": (_vm.publicoAlvo.nr_jovens)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.publicoAlvo, "nr_jovens", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('Número de jovens atendidos')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Número de jovens atendidos')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.first('Atende mulheres')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Atende mulheres?")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mulheresBool),
      expression: "mulheresBool"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "data-cy": "mulheresBool",
      "name": "Atende mulheres"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.mulheresBool = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.alteraMulheres]
    }
  }, [_c('option', {
    attrs: {
      "value": "Sim"
    }
  }, [_vm._v("Sim")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Não"
    }
  }, [_vm._v("Não")])])]), _vm._v(" "), (_vm.errors.first('Atende mulheres')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Atende mulheres')))]) : _vm._e()])]), _vm._v(" "), (_vm.mulheresBool === 'Sim') ? _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.first('Número de mulheres atendidas')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Número de mulheres atendidas:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.publicoAlvo.nr_mulheres),
      expression: "publicoAlvo.nr_mulheres"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.mulheresBool == 'Sim'
      }),
      expression: "{required: mulheresBool=='Sim'}"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Número de mulheres atendidas",
      "type": "number",
      "min": "1",
      "max": _vm.publicoAlvo.nr_participantes_diretos
    },
    domProps: {
      "value": (_vm.publicoAlvo.nr_mulheres)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.publicoAlvo, "nr_mulheres", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('Número de mulheres atendidas')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Número de mulheres atendidas')))]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "col-md-4 col-md-offset-2"
  }, [_c('button', {
    staticClass: "btn btn-confirm btn-flat",
    attrs: {
      "data-cy": "adiciona-publico",
      "id": "proposal-audience-add",
      "type": "button"
    },
    on: {
      "click": _vm.onAdd
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Ok")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-back btn-flat",
    attrs: {
      "id": "proposal-audience-cancel",
      "type": "button"
    },
    on: {
      "click": _vm.cancelaPublico
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cancelar")])])])])]) : _vm._e(), _vm._v(" "), _c('vue-snotify')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4"
  }, [_c('span', {
    staticClass: "message",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(" * Os relatórios de execução do projeto, exigirão os dados dos participantes diretos.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6b9a2036!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/publicoAlvo.vue
// module id = 2002
// module chunks = 1